import { ProjectDataNavisionSegmentInfo } from './project-data-navisionSegmentInfo-entity';
import { ProjectDataNavisionvProductItem } from './project-data-navisionvProductItem-entity';

export class ProjectDataNavisionSegmento {
	public segmentInfo: ProjectDataNavisionSegmentInfo = new ProjectDataNavisionSegmentInfo();
	public vProductItem: ProjectDataNavisionvProductItem[] = [];
}